"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _CheckCircle = _interopRequireDefault(require("@tvg/fuse-icons/lib/CheckCircle"));
var _Error = _interopRequireDefault(require("@tvg/fuse-icons/lib/Error"));
var _Info = _interopRequireDefault(require("@tvg/fuse-icons/lib/Info"));
var _Warning = _interopRequireDefault(require("@tvg/fuse-icons/lib/Warning"));
var _react = _interopRequireDefault(require("react"));
var _server = require("react-dom/server");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var variantConfig = {
  warning: {
    background: 'var(--color-universal-bronzeLight)',
    iconColour: 'var(--color-universal-bronzeMid)',
    icon: (0, _server.renderToStaticMarkup)(/*#__PURE__*/_react["default"].createElement(_Warning["default"], null))
  },
  error: {
    background: 'var(--color-universal-redLight)',
    iconColour: 'var(--color-universal-redMid)',
    icon: (0, _server.renderToStaticMarkup)(/*#__PURE__*/_react["default"].createElement(_Error["default"], null))
  },
  success: {
    background: 'var(--color-universal-greenLight)',
    iconColour: 'var(--color-universal-greenMid)',
    icon: (0, _server.renderToStaticMarkup)(/*#__PURE__*/_react["default"].createElement(_CheckCircle["default"], null))
  },
  information: {
    background: 'var(--color-universal-blueLight)',
    iconColour: 'var(--color-universal-blueMid)',
    icon: (0, _server.renderToStaticMarkup)(/*#__PURE__*/_react["default"].createElement(_Info["default"], null))
  }
};
var _default = exports["default"] = variantConfig;